import { render } from "./EdicionTicketSoporte.vue?vue&type=template&id=0e23714d&scoped=true"
import script from "./EdicionTicketSoporte.vue?vue&type=script&lang=js"
export * from "./EdicionTicketSoporte.vue?vue&type=script&lang=js"

import "./EdicionTicketSoporte.vue?vue&type=style&index=0&id=0e23714d&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e23714d"]])

export default __exports__